import { Link } from "react-router-dom";
import React, { useState } from "react";
import queryString from "query-string";

function PodcastApp(props) {
  const [answer, setAnswer] = useState("");
  const params = queryString.parse(props.location.search);
  const app = params.app || "";

  return (
    <div className="center-static">
      <h1 className="headline" style={{ marginBottom: "0px" }}>
        Do you use a podcast app?
      </h1>
      {/* <h1 className="subheadline">Help us personalize your experience</h1> */}
      <button
        className="transparent-button clickable"
        style={{
          border: answer === "yes" && "3px solid #fb1c7f",
          fontSize: "xx-large",
        }}
        onClick={(e) => {
          setAnswer("yes");
        }}
      >
        Yes
      </button>
      <button
        className="transparent-button clickable"
        style={{
          border: answer === "no" && "3px solid #fb1c7f",
          fontSize: "xx-large",
        }}
        onClick={(e) => {
          setAnswer("no");
        }}
      >
        No
      </button>
      {answer === "yes" ? (
        <div>Awesome, most apps are supported, except Spotify</div>
      ) : (
        answer === "no" && (
          <div>
            That's cool! You can listen in the browser.
          </div>
        )
      )}
      {answer && (
        <div
          className="cta-div"
          style={{ position: "static", marginTop: "20px" }}
        >
          <Link
            to={`/onboarding/types${app && "?app=chrome"}`}
            className="cta-button"
            onClick={(e) => {}}
          >
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div>
                <div>Continue</div>
              </div>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
}

export default PodcastApp;
